import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "customerChangePasswordComponent",
  class: "auth-main-wrapper col-lg-5 col-md-6 col-sm-12 mt-5"
}
const _hoisted_2 = { class: "auth-inner-div w-100 text-center" }
const _hoisted_3 = { class: "auth-header" }
const _hoisted_4 = { class: "auth-inner-form-div" }
const _hoisted_5 = { class: "auth-input" }
const _hoisted_6 = {
  key: 0,
  class: "auth-inner-div w-100 pt-3"
}
const _hoisted_7 = { class: "font-small order-4 error-color" }
const _hoisted_8 = { class: "auth-inner-div w-100 pt-4 pb-5" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  key: 0,
  class: "customer-loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordRequirementsCardComponent = _resolveComponent("PasswordRequirementsCardComponent")!
  const _component_InputComponent = _resolveComponent("InputComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('password_change')), 1)
    ]),
    _createVNode(_component_PasswordRequirementsCardComponent),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerForm.inputs, (input) => {
          return (_openBlock(), _createBlock(_component_InputComponent, {
            class: "w-100 mx-auto",
            "name-input": input.name,
            "data-type": input.dataType,
            placeholder: _ctx.$t(input.placeholder),
            data: input.value,
            "onUpdate:data": ($event: any) => ((input.value) = $event),
            msg: input.validation
          }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"]))
        }), 256))
      ])
    ]),
    (_ctx.backendValidationErrors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backendValidationErrors, (error) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t(error)), 1))
          }), 256))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: _normalizeClass(["auth-customer-login-button w-100", {'less-padding-06': _ctx.loading}]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePassword()), ["prevent"])),
        disabled: _ctx.loading
      }, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('submit')), 1),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11))
          : _createCommentVNode("", true)
      ], 10, _hoisted_9)
    ])
  ]))
}